﻿import { ProFunnelModel } from "./profunnel.model";

export class ProFunnelListModel {
    sourceData: Array<ProFunnelModel> = new Array<ProFunnelModel>();
    totalCount: number = 0;
}
